import { getSessionUserIdDecision } from '@/features/auth/utils/tokenStorage';
import { getAdminViewAsUserId } from '@/features/auth/services/adminViewAs';

export const getDashboardStorageScope = (): string => {
  if (typeof window === 'undefined') return 'anonymous';

  const userIdDecision = getSessionUserIdDecision();
  // Explicit logout must not revive an old profile or stale view-as metadata.
  if (userIdDecision === null) return 'anonymous';

  const viewAsUserId = getAdminViewAsUserId();
  if (viewAsUserId) return `view-as:${viewAsUserId}`;
  if (userIdDecision !== undefined) return `self:${userIdDecision}`;

  // Before the first explicit user decision, retain legacy display preferences.
  try {
    const rawUser =
      window.sessionStorage.getItem('user') ||
      window.localStorage.getItem('user');
    const user = rawUser ? JSON.parse(rawUser) : null;
    if (user?.id) {
      return `self:${user.id}`;
    }
  } catch {
    // Browser storage is optional for dashboard defaults.
  }

  return 'anonymous';
};

export const scopedDashboardKey = (key: string): string =>
  `${key}:${getDashboardStorageScope()}`;
